import { Outlet, useLocation, useNavigate } from "react-router-dom";

import React, { useState, useEffect, useRef } from 'react';
import styled from "styled-components";
import Logo from '../components/Icon/Logo';
import DashboardIcon from '../components/Icon/Dashboard';
import ReportBuilder from '../components/Icon/ReportBuilder';
import NewProducts from '../components/Icon/NewProducts';
import Search from '../components/Icon/Search';
import ReachOut from '../components/Icon/ReachOut';
import PlayButton from '../components/Icon/PlayButton';
import Bell from '../components/Icon/Bell';
import userPF from '../assets/images/user.png';
import { SignOut } from '../components/Icon/Signout';
import VideoModal from "./VideoModal";
import { Terms } from "./Icon/Terms";
import { PrivacyPolicyIcon } from "./Icon/PrivacyPolicyIcon";
import { useData } from "../context/DataProvider";
import { cosmeticIQApi } from "../service/api";
import Trends from "./Icon/Trends";
import Saved from "./Icon/Saved";

const Layout = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const {data,setIsAuthenticated} = useData();
    const userData = data.userData || {};
    const location = useLocation();
const mainContentRef = useRef(null);

useEffect(() => {
    if (mainContentRef.current) {
        mainContentRef.current.scrollTo({ top: 0, behavior: 'instant' });
    }
}, [location.pathname]);
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth >= 768) {
                setSidebarOpen(true);
            } else {
                setSidebarOpen(false);
            }
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSignOut = () => {
        cosmeticIQApi.logout();
        localStorage.clear();
        setIsAuthenticated(false);
        navigate('/login');
    };

    const getActivePageText = () => {
        switch (location.pathname) {
            case "/":
            case "/dashboard":
                return "Dashboard";
            case "/report-builder":
                return "Report Builder";
            case "/new-products":
                return "New Products";
            case "/reach-out":
                return "Reach Out";
            case "/terms-of-use":
                return "Terms & Conditions";
            case "/privacy-policy":
                return "Privacy Policy";    
            case "/account":
                return "Account Settings";
            case "/most-searched":
                return "Most Searched";
            case "/trends":
                return "Trends";    
            case "/saved":
                return "My Saved Views & Reports";   
            default:
                return "";
        }
    };

    return (
        <Container>
            {isMobile && (
                <MobileHeader>
                    <MenuButton onClick={toggleSidebar}>
                        ☰
                    </MenuButton>
                    <MobileLogo>
                        <Logo />
                    </MobileLogo>
                    <MobileUser onClick={() => navigate("/account")}>
                        <UserProfile src={userPF} alt="User profile" />
                    </MobileUser>
                </MobileHeader>
            )}

            <SidebarContainer open={sidebarOpen}>
                <SidebarStripArea>
            <SidebarStrip />
            </SidebarStripArea>
                <Sidebar>
                    
                    <SidebarArea>
                        <LogoArea>
                            <Logo />
                        </LogoArea>
                        <SidebarOptions>
                            <Optionn onClick={() => navigate("/dashboard")}>
                                <DashboardIcon color={location.pathname === "/" || location.pathname === "/dashboard" ? '#2F3237' : '#20232799'}/>
                                <OptionText isActive={location.pathname === "/" || location.pathname === "/dashboard"}>Dashboard</OptionText>
                            </Optionn>

                            <Optionn onClick={() => navigate("/report-builder")}>
                                <ReportBuilder color={location.pathname === "/report-builder" ? '#2F3237' : '#20232799'}/>
                                <OptionText isActive={location.pathname === "/report-builder"}>Report Builder</OptionText>
                            </Optionn>

                            <Optionn onClick={() => navigate("/new-products")}>
                                <NewProducts color={location.pathname === "/new-products" ? '#2F3237' : '#20232799'}/>
                                <OptionText isActive={location.pathname === "/new-products"}>New Products</OptionText>
                            </Optionn>

                            <Optionn onClick={() => navigate("/most-searched")}>
                                <Search color={location.pathname === "/most-searched" ? '#2F3237' : '#20232799'}/>
                                <OptionText isActive={location.pathname === "/most-searched"}>Most Searched</OptionText>
                            </Optionn>
                            <Optionn onClick={() => navigate("/trends")}>
                                <Trends color={location.pathname.startsWith("/trend") ? '#2F3237' : '#20232799'}/>
                                <OptionText isActive={location.pathname.startsWith("/trend")}>Trends</OptionText>
                            </Optionn> 
                              <Optionn onClick={() => navigate("/saved")}>
                                <Saved color={location.pathname === "/saved" ? '#2F3237' : '#20232799'}/>
                                <OptionText isActive={location.pathname === "/saved"}>Saved</OptionText>
                            </Optionn>

                            <ReachoutButton onClick={() => navigate("/reach-out")}>
                                <ReachOut />
                                <ReachoutText>Reach out</ReachoutText>
                            </ReachoutButton>
                        </SidebarOptions>
                    </SidebarArea>
                    <SidebarOptions style={{ height:152}}>
                    <Optionn onClick={() => navigate("/privacy-policy")}>
                           <PrivacyPolicyIcon/> 
                           <OptionText style={{color: '#2F3237'}}>Privacy Policy</OptionText>
                        </Optionn>
                    <Optionn onClick={() => navigate("/terms-of-use")}>
                           <Terms/> 
                           <OptionText style={{color: '#2F3237'}}>Terms of Use</OptionText>
                        </Optionn>
                        <Optionn onClick={handleSignOut}>
                            <SignOut />
                            <OptionText style={{color: '#2F3237'}}>Sign out</OptionText>
                        </Optionn>
                    </SidebarOptions>
                </Sidebar>
                {isMobile && (
                    <Overlay open={sidebarOpen} onClick={() => setSidebarOpen(false)} />
                )}
            </SidebarContainer>

            <MainContent ref={mainContentRef}  sidebarOpen={sidebarOpen} isMobile={isMobile}>
                {!isMobile && (
                    <DasboardNav>
                        <DasboardNav1>
                            <DashboardText>{getActivePageText()}</DashboardText>
                            <VideoArea>
                                <VideoButton onClick={() => setIsModalOpen(true)}>
                                    <PlayButton />
                                    <VideoButtonTxt>Watch the onboarding video</VideoButtonTxt>
                                </VideoButton>
                                <VideoModal
                                    isOpen={isModalOpen} 
                                    onClose={() => setIsModalOpen(false)} 
                                    videoUrl={process.env.REACT_APP_VIDEO_URL}
                                />
                                <AnP>
                                    {/* <Bell /> */}
                                    <AnP1 onClick={() => navigate("/account")}>
                                        <UserPF>
                                            <UserProfile src={userPF} />
                                        </UserPF>
                                        <AnP1Text>{userData.firstName || ''} {userData.lastName || ''}</AnP1Text>
                                    </AnP1>
                                </AnP>
                            </VideoArea>
                        </DasboardNav1>
                    </DasboardNav>
                )}

                {isMobile && (
                    <MobileTitle>
                        {getActivePageText()}
                    </MobileTitle>
                )}

                <Outlet />
            </MainContent>
        </Container>
    );
};

export default Layout;

// Styled components (similar to Dashboard component)
const Container = styled.div`
    display: flex;
    padding: 0;
    position: relative;
    
    width: 100%;
    height: 100vh;
    overflow: hidden;
    

    

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const MobileHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    background:#F9F9F9;
    
    z-index: 10;
`;

const MenuButton = styled.button`
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    font-size: 24px;
`;

const MobileLogo = styled.div`
    transform: scale(0.8);
`;

const MobileUser = styled.button`
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
`;

const MobileTitle = styled.h1`
    font-size: 24px;
    font-weight: 600;
    margin: 16px 0;
    padding: 0 16px;
    color: #2F3237;
    font-family: PPMori;
`;

const SidebarContainer = styled.div`
    position: ${props => props.open ? 'relative' : 'absolute'};
    left: ${props => props.open ? '0' : '-280px'};
    height: 100%;
    // z-index: -100;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    


    @media (max-width: 768px) {
        position: fixed;
        left: ${props => props.open ? '0' : '-280px'};
    }
`;

const Overlay = styled.div`
    display: ${props => props.open ? 'block' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
`;

const Sidebar = styled.div`
    background: #FFFFFF;
    // width:200px;
    
    height: 100%;
    padding: 0px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
`;
const SidebarStrip = styled.div`
background: linear-gradient(180deg, #BDDEFF 0%, #F6FFDB 50%, #DCFFAD 100%);
height: 100%;
width: 6px;
border-top-right-radius: 6px;
border-bottom-right-radius: 6px;

`
const SidebarStripArea = styled.div`
padding: 20px 0px;

`
const SidebarArea = styled.div`
    gap: 30px;
    display: flex;
    flex-direction: column;
`;

const LogoArea = styled.div`
    padding: 40px 24px 0px 24px;
    display: flex;
    // justify-content: center;
`;

const SidebarOptions = styled.div`
    padding: 0px 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const Optionn = styled.button`
    padding: 8px 12px;
    gap: 8px;
    border-radius: 12px;
    border: none;
    background: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
        background: #F6F6F6;
    }
`;

const OptionText = styled.div`
    font-family: PPMori;
    font-size: 14px;
    font-weight: 600;
    line-height: 16.8px;
    text-align: left;
    color: ${({ isActive }) => (isActive ? "#2F3237" : "#20232799")};
`;

const ReachoutButton = styled.button`
    width: 100%;
    cursor: pointer;
    height: 36px;
    font-family: PPMori;
    padding: 8px 12px;
    gap: 8px;
    border-radius: 64px;
    border: none;
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    display: flex;
    align-items: center;
    // justify-content: center;
    margin-top: 8px;
`;

const ReachoutText = styled.p`
    font-size: 14px;
    font-weight: 700;
    line-height: 16.8px;
    letter-spacing: -0.01em;
    text-align: center;
    color: #2F3237;
    margin: 0;
`;

const MainContent = styled.div`
    flex: 1;
    margin-right:12px;
    margin-top:12px;
    margin-bottom:12px;
    overflow-y: auto;
    background: #F9F9F9;
    border-radius: ${props => props.isMobile ? '0' : '32px'};
    margin-left: ${props => (props.sidebarOpen && !props.isMobile) ? '0' : '0'};
    transition: margin-left 0.3s ease;
    width: ${props => (props.sidebarOpen && !props.isMobile) ? 'calc(100% - 250px)' : '100%'};

    @media (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        border-radius: 0;
    }
`;

const DasboardNav = styled.div`
    height: 88px;
    width: 100%;
    

    @media (max-width: 1024px) {
        height: 70px;
    }
`;

const DasboardNav1 = styled.div`
    padding: 0px 30px 0px 40px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1024px) {
        padding: 0px 20px;
    }
`;

const VideoArea = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 1024px) {
        gap: 8px;
    }
`;

const DashboardText = styled.h1`
    font-size: 32px;
    font-family: PPMori;
    font-weight: 600;
    line-height: 35.2px;
    letter-spacing: -0.01em;
    color: #2F3237;
    margin: 0;
  
`;

const VideoButton = styled.button`
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 0px 20px 0px 16px;
    gap: 8px;
    border-radius: 1000px;
    border: none;
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    height: 36px;

    @media (max-width: 1024px) {
        padding: 0px 12px 0px 8px;
        gap: 4px;
    }

    @media (max-width: 900px) {
        display: none;
    }
`;

const VideoButtonTxt = styled.p`
    font-size: 14px;
    font-family: PPMori;
    font-weight: 700;
    line-height: 16.8px;
    letter-spacing: -0.01em;
    text-align: center;
    color: #2F3237;
    margin: 0;

    @media (max-width: 1024px) {
        font-size: 12px;
    }
`;

const AnP = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;

    @media (max-width: 1024px) {
        gap: 8px;
    }
`;

const AnP1 = styled.button`
    padding: 4px 12px 4px 4px;
    gap: 8px;
    border-radius: 1000px;
    border: none;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    cursor: pointer;

    @media (max-width: 1024px) {
        padding: 4px 8px 4px 4px;
        gap: 6px;
    }
`;

const AnP1Text = styled.p`
    font-size: 14px;
    font-weight: 600;
    line-height: 16.8px;
    text-align: center;
    color: #2F3237;
    font-family: PPMori;
    margin: 0;

    @media (max-width: 1024px) {
        font-size: 12px;
    }
`;

const UserPF = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 1000px;
    
    border: 2px solid #F9F9F9;

    @media (max-width: 1024px) {
        width: 28px;
        height: 28px;
    }
`;

const UserProfile = styled.img`
    object-fit: contain;
    border-radius: 1000px;
    width: 100%;
    height: 100%;
`;